//Install
import React, { Component } from "react";
//Install
import P02603 from "../../../../../../Media/Image/036.jpg";

//Element
class Image extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB u46g69" },
            //Element
            React.createElement("img", { alt: "Data", title: "Data", src: P02603, width: "306", height: "auto" })
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Image;